<template>
    <div class="c-sales-admin">
        <BackButton routeName="appointment-list"/>

        <div class="inner-content full" v-if="loggedInUser">
            <h1>{{$t('sales_admin.title')}}</h1>
            <div class="shop">{{$t('sales_select.shop')}}: {{loggedInUser.shop.name}}</div>

            <div class="list-wrapper">
                <div class="list-container">
                    <div class="list" id="list" v-if="!isNewSales">
                        <div v-for="sale in sales" :key="sale.id" class="list--item"
                            :class="{selected : selectedSales !== null && sale.id == selectedSales.id}"
                            @click.prevent="setSelectedSales(sale)">
                            <div>
                                {{sale.firstname}} {{sale.lastname}}
                            </div>
                            <div class="list--item--btns">
                                <button @click.prevent="deleteSales(sale)" class="btn-delete" v-if="!sale.is_admin"></button>
                            </div>
                        </div>
                    </div>
                    <Scrollbar containerid="list" :count="sales.length"/>
                </div>

                <div v-if="selectedSales !== null" class="detail-pane">
                    <div class="">
                        <div>
                            <input type="text" class="inputfield" v-model="selectedSales.firstname" :placeholder="$t('generic.firstname')" :class="{error:error.firstname}">
                            <input type="text" class="inputfield" v-model="selectedSales.lastname" :placeholder="$t('generic.lastname')" :class="{error:error.lastname}">
                        </div>
                        <div class="checkbox-row">
                            <Checkbox v-model:checked="selectedSales.is_admin" :label="$t('sales_admin.admin')"/>
                        </div>
                        <div class="checkbox-row">
                            <Checkbox v-model:checked="selectedSales.auto_deactivate" :label="$t('sales_admin.temp')"/>
                        </div>
                        <div class="checkbox-row">
                            <Checkbox v-model:checked="selectedSales.limited" :label="$t('sales_admin.limited')"/>
                        </div>
                        <div class="detail-action-btns">
                            <button @click.prevent="closeSalesDetail" class="btn-basic bordered">{{$t('generic.cancel')}}</button>
                            <button @click.prevent="saveSalesDetail" class="btn-basic blue">{{$t('generic.save')}}</button>
                        </div>
                    </div>
                </div>
            </div>

            <div class="action-btns">
                <button class="btn-basic blue" @click.prevent="createSales">{{$t('sales_admin.new_sales')}}</button>
            </div>
        </div>

        <ConfirmPopup v-if="confirmDelete"
            :title="$t('sales_admin.confirm_delete')"
            color="red"
            @cancel="cancelDeletePopup"
            @confirm="clickConfirmDelete"
         />
    </div>
</template>

<script>
import BackButton from "@/components/app/BackButton.vue";
import Checkbox from "@/components/Checkbox.vue";
import ConfirmPopup from "@/components/app/ConfirmPopup.vue";
import Scrollbar from "@/components/Scrollbar.vue";
import LoginMixin from "@/mixins/LoginMixin";
import {deepCopyObject} from "@/utils/utils";
import {apiStore} from "@/stores/api";

export default {
    name : "SalesAdmin",
    components: {
        BackButton,
        Checkbox,
        ConfirmPopup,
        Scrollbar
    },
    mixins : [LoginMixin],
    data() {
        return {
            sales : [],
            selectedSales : null,
            salesToDelete : null,
            isNewSales : false,
            confirmDelete : false,
            error : {
                firstname : false,
                lastname : false
            }
        };
    },

    created() {
        this.getSalesForShop();
    },

    methods : {
        async getSalesForShop() {
            this.sales = await apiStore().getSalesForShop();
            this.sales.sort((x, y) => x.firstname.toLowerCase() < y.firstname.toLowerCase() ? -1 : 1);
        },

        setSelectedSales(sale) {
            this.selectedSales = deepCopyObject(sale);
            this.isNewSales = false;
        },

        createSales() {
            this.selectedSales = {
                firstname : "",
                lastname : "",
                auto_deactivate : false,
                limited : false,
                is_admin : false,
                shop_id : this.loggedInUser.shop_id
            };
            this.isNewSales = true;
        },

        async saveSalesDetail() {
            let hasError = false;
            for (const key in this.error) {
                this.error[key] = this.selectedSales[key] === "";
                if (this.error[key]) {
                    hasError = true;
                }
            }

            if (!hasError) {
                if (this.isNewSales) {
                    await apiStore().createSales(this.selectedSales);
                } else {
                    await apiStore().updateSales(this.selectedSales);
                }
                this.selectedSales = null;
                this.isNewSales = false;
                this.$router.go();
            }
        },

        deleteSales(sales) {
            this.confirmDelete = true;
            this.salesToDelete = sales;
        },

        cancelDeletePopup() {
            this.confirmDelete = false;
        },

        async clickConfirmDelete() {
            this.confirmDelete = false;
            this.selectedSales = null;

            await apiStore().deleteSales(this.salesToDelete);
            this.getSalesForShop();

            this.salesToDelete = null;
            this.$router.go();
        },

        closeSalesDetail() {
            this.selectedSales = null;
            this.isNewSales = false;
        }
    }
};
</script>

<style lang="scss" scoped>
    .c-sales-admin {
        height : 100%;

        .shop {
            font-size: 1.2em;
            margin-left: 4.8em;
            margin-bottom : 2em;
            @include slideIntroAnimation(basicSlideIntro, 500ms, 450ms);
        }

        .list-container {
            display: flex;
            width : 50%;

            .list {
                width : 100%;
                max-height: 35vh;
                padding: 0 1em;

                &--item {
                    &.selected {
                        background : $color-red;
                        color : white;
                    }
                }
            }
        }

        .list-wrapper {
            display: flex;
            width: 100%;
        }

        .detail-pane {
            @include slideIntroAnimation(basicSlideIntro, 450ms, 50ms);
            margin-left: 2rem;
            width : 50%;

            .inputfield {
                margin-right : 2rem;
            }

            .detail-action-btns {
                margin-top : 1em;
            }
            .btn-basic {
                margin-right : 1em;
            }
            .checkbox-row {
                margin-top : .75em;
                margin-bottom : .75em;
            }
        }

        .action-btns {
            position: absolute;
            bottom: 0;

            .btn-basic {
                margin : 0 .5rem;
            }
        }
    }
</style>